// extracted by mini-css-extract-plugin
module.exports = {"frame":"LoadingFrame_frame__2_YhC","fullPage":"LoadingFrame_fullPage__3ONFz"};